<template>
  <div class="licenses">
    <h2 class="text__center">Licenses</h2>
    <section class="tile licenses--info">
      <h3 class="content__heading">Information</h3>
      <div class="licenses--info-content">
        <p class="text__center intro">
          Licensing information appears on several websites, see the
          <span>
            <router-link to="/information">information</router-link>
          </span>
          where the licenses appear online.
        </p>
        <span class="text__bold">To Edit:</span>
        <span>Select a state and press the edit button to edit the content for that state on a given website</span>
        <span class="text__bold">To Delete:</span>
        <span>Select a state and press the delete button to remove the state from the licenses page for a given website</span>
        <span class="text__bold">To Add:</span>
        <span>Click the green "plus" sign on the website where you want to add the license information</span>
      </div>
    </section>
    <section class="licenses--sites tile--grid">
      <LicenseWebsite v-for="website in getLicenseSites" :key="website" :website="website" />
    </section>
    <LicenseEdit :license="getActiveLicense" />
    <LicenseCreate />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import LicenseEdit from "./LicenseEdit";
import LicenseWebsite from "./LicenseWebsite";
import LicenseCreate from "./LicenseCreate";

export default {
  components: {
    LicenseEdit,
    LicenseWebsite,
    LicenseCreate
  },
  computed: {
    ...mapGetters(["getLicenseSites", "getActiveLicense"])
  }
};
</script>

<style scoped lang="scss">
</style>